import { Controller, useFormContext } from "react-hook-form";
import { Field, Input } from "@hulahoop/ui";
import { OptionSelect } from "@/components/shared/forms/OptionSelect";
import type { Option } from "@/domain/types/option";
import type { RepresentativeFieldLabels } from "@/domain/types/representative";

export function RepresentativeFields({
  name,
  positions,
  labels,
  autoFocus,
}: {
  name: string;
  positions: readonly Option[];
  labels: RepresentativeFieldLabels;
  autoFocus?: boolean;
}) {
  const { register, control, getFieldState, formState } = useFormContext();
  const path = (field: string) => `${name}.${field}`;
  const errorOf = (field: string) => getFieldState(path(field), formState).error?.message;
  return (
    <>
      <Field label={labels.fullName} required error={errorOf("fullName")}>
        <Input
          autoFocus={autoFocus}
          placeholder={labels.fullNamePlaceholder}
          {...register(path("fullName"))}
        />
      </Field>
      <div className="grid gap-(--card-gap) sm:grid-cols-2">
        <Field label={labels.dni} required error={errorOf("dni")}>
          <Input placeholder={labels.dniPlaceholder} {...register(path("dni"))} />
        </Field>
        <Field label={labels.position} required error={errorOf("position")}>
          <Controller
            control={control}
            name={path("position")}
            render={({ field }) => (
              <OptionSelect
                value={field.value || null}
                onValueChange={(position) => field.onChange(position ?? "")}
                options={positions}
                label={labels.position}
              />
            )}
          />
        </Field>
      </div>
      <div className="grid gap-(--card-gap) sm:grid-cols-2">
        <Field label={labels.phone}>
          <Input placeholder={labels.phonePlaceholder} {...register(path("phone"))} />
        </Field>
        <Field label={labels.email} error={errorOf("email")}>
          <Input type="email" placeholder={labels.emailPlaceholder} {...register(path("email"))} />
        </Field>
      </div>
    </>
  );
}
